"use strict";

var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Argument = _interopRequireDefault(require("./Argument"));

var _MarkdownContent = _interopRequireDefault(require("./MarkdownContent"));

var _TypeLink = _interopRequireDefault(require("./TypeLink"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var FieldDoc = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(FieldDoc, _react$default$Compon);

  var _super = _createSuper(FieldDoc);

  function FieldDoc() {
    _classCallCheck(this, FieldDoc);

    return _super.apply(this, arguments);
  }

  _createClass(FieldDoc, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return this.props.field !== nextProps.field;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var field = this.props.field;
      var argsDef;

      if (field.args && field.args.length > 0) {
        argsDef = _react.default.createElement("div", {
          className: "doc-category"
        }, _react.default.createElement("div", {
          className: "doc-category-title"
        }, 'arguments'), field.args.map(function (arg) {
          return _react.default.createElement("div", {
            key: arg.name,
            className: "doc-category-item"
          }, _react.default.createElement("div", null, _react.default.createElement(_Argument.default, {
            arg: arg,
            onClickType: _this.props.onClickType
          })), _react.default.createElement(_MarkdownContent.default, {
            className: "doc-value-description",
            markdown: arg.description
          }));
        }));
      }

      return _react.default.createElement("div", null, _react.default.createElement(_MarkdownContent.default, {
        className: "doc-type-description",
        markdown: field.description || 'No Description'
      }), field.deprecationReason && _react.default.createElement(_MarkdownContent.default, {
        className: "doc-deprecation",
        markdown: field.deprecationReason
      }), _react.default.createElement("div", {
        className: "doc-category"
      }, _react.default.createElement("div", {
        className: "doc-category-title"
      }, 'type'), _react.default.createElement(_TypeLink.default, {
        type: field.type,
        onClick: this.props.onClickType
      })), argsDef);
    }
  }]);

  return FieldDoc;
}(_react.default.Component);

exports.default = FieldDoc;

_defineProperty(FieldDoc, "propTypes", {
  field: _propTypes.default.object,
  onClickType: _propTypes.default.func
});